import createTheme from '@@/create-theme';

export default createTheme({
    app: () => import('./components/root'),
    locales: ['zh-CN', 'en']
});
